<template>
  <div id="hrese3e">
    Online Test Backend
  </div>
</template>

<script>
import { router } from 'src/router'

export default {
  name: 'hrese3e',
  data () {
    return {
      app: this.$parent.$parent.$parent
    }
  },
  created () {
    window.open('/backoffice/auth/#store-profile')
    router.push({ name: 'home' })
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?4f536f36